module.exports = __webpack_public_path__ + "img/bacha_no.f3776b38.png";